export default __webpack_public_path__ + "static/media/icons-close-green-18-px.01130901.svg";